import { render, staticRenderFns } from "./appWgt.vue?vue&type=template&id=537d62d2&scoped=true"
import script from "./appWgt.vue?vue&type=script&lang=js"
export * from "./appWgt.vue?vue&type=script&lang=js"
import style0 from "./appWgt.vue?vue&type=style&index=0&id=537d62d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537d62d2",
  null
  
)

export default component.exports